// src/app/services/orquestador/orquestador.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { BodyActualizacionLead } from 'src/app/interfaces/body_actualizacion_lead';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { BodyCumulo } from 'src/app/interfaces/body_cumulo';
import { BodyPolizas } from 'src/app/interfaces/body_Polizas';
import { BodyPolizasPropietario } from 'src/app/interfaces/body_polizas_propietario';
import { BodyRiesgosConsultable } from 'src/app/interfaces/body_riesgos_consultable';
import { BodyDatosInmueble } from 'src/app/interfaces/bodyDatosInmueble';
import { BodyInquilino } from 'src/app/interfaces/bodyInquilino';
import { BodyPropietario } from 'src/app/interfaces/bodyPropietario';
import { Home } from 'src/app/interfaces/home';
import { HomeResponse } from 'src/app/interfaces/home-response';
import { InfoArrend } from 'src/app/interfaces/info-arrend';
import { InfoArrendNo } from 'src/app/interfaces/InfoArrendNo';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { ResponseCotizador } from 'src/app/interfaces/response_cotizador';
import { ResponseCumulo } from 'src/app/interfaces/response_cumulo';
import { ResponseDatos } from 'src/app/interfaces/response_datos';
import { ResponseDatosActualizacionLead } from 'src/app/interfaces/response_datos_actualizacion_lead';
import { ResponseInmueble } from 'src/app/interfaces/response_inmueble';
import { ResponsePolizasPropietario } from 'src/app/interfaces/response_poliza_propietario';
import { ResponsePolizas } from 'src/app/interfaces/response_Polizas';
import { ResponseRiesgosConsultable } from 'src/app/interfaces/response_reisgos_consultable';
import { PlanModels } from 'src/app/models/plan_models';
import { environment } from 'src/environments/environment';
import { DataLayerService } from '../dataLeyer/data-leyer.service';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class OrquestadorService {
  
  baseUri = environment.URL_MULESOFT_ORQUESTADOR;
  
  constructor(
    private dataLayerService: DataLayerService,
    private http: HttpClient,
    private authService: AuthService
  ) { }

  /**
   * Realiza una petición POST con autenticación automática
   * @param body - Cuerpo de la petición
   * @returns Observable con la respuesta
   */
  private makeAuthenticatedRequest<T>(body: any): Observable<T> {
    return this.authService.createAuthHeaders().pipe(
      switchMap(headers => {
        const requestBody = JSON.stringify(body);
        const parsedBody = JSON.parse(requestBody);
        return this.http.post<T>(this.baseUri, parsedBody, { headers });
      })
    );
  }

  public postOrquestador(body: any): Observable<any> {
    return this.makeAuthenticatedRequest<any>(body);
  }

  public postOrquestadorIntermedia(body: Home): Observable<HomeResponse> {
    return this.makeAuthenticatedRequest<HomeResponse>(body);
  }

  public postOrquestadorSinRespuesta(body: InfoArrend): Observable<ResponseServices> {
    return this.makeAuthenticatedRequest<ResponseServices>(body);
  }

  public postOrquestadorHome(body: InfoArrend): Observable<ResponsePolizas> {
    return this.makeAuthenticatedRequest<ResponsePolizas>(body);
  }

  public postOrquestadorHomeNo(body: InfoArrendNo): Observable<ResponsePolizas> {
    return this.makeAuthenticatedRequest<ResponsePolizas>(body);
  }

  public postOrquestadorEnvioGen(body: any): Observable<ResponseServices> {
    return this.makeAuthenticatedRequest<ResponseServices>(body);
  }

  public postOrquestadorPlanes(body: BodyCargaPlanes): Observable<PlanModels> {
    return this.makeAuthenticatedRequest<PlanModels>(body);
  }

  public postOrquestadorPolizas(body: BodyPolizas): Observable<ResponsePolizas> {
    return this.makeAuthenticatedRequest<ResponsePolizas>(body);
  }

  public postOrquestadorPolizasPropietario(body: BodyPolizasPropietario): Observable<ResponsePolizasPropietario> {
    return this.makeAuthenticatedRequest<ResponsePolizasPropietario>(body);
  }

  public postOrquestadorCumulo(body: BodyCumulo): Observable<ResponseCumulo> {
    return this.makeAuthenticatedRequest<ResponseCumulo>(body);
  }

  public postOrquestadorDatosPropiertario(body: BodyPropietario): Observable<ResponsePolizasPropietario> {
    return this.makeAuthenticatedRequest<ResponsePolizasPropietario>(body);
  }

  public postOrquestadorDatosInquilino(body: BodyInquilino): Observable<ResponseDatos> {
    return this.makeAuthenticatedRequest<ResponseDatos>(body);
  }

  public postOrquestadoRiesgosConsultables(body: BodyRiesgosConsultable): Observable<ResponseRiesgosConsultable> {
    return this.makeAuthenticatedRequest<ResponseRiesgosConsultable>(body);
  }

  public postOrquestadorDatosInmueble(body: BodyDatosInmueble): Observable<ResponseInmueble> {
    return this.makeAuthenticatedRequest<ResponseInmueble>(body);
  }

  public postOrquestadorActualizacionLead(body: BodyActualizacionLead): Observable<ResponseDatosActualizacionLead> {
    return this.makeAuthenticatedRequest<ResponseDatosActualizacionLead>(body);
  }

  public postOrquestadorCotizador(body: any): Observable<ResponseCotizador> {
    return this.makeAuthenticatedRequest<ResponseCotizador>(body);
  }

  /**
   * Métodos adicionales para gestión de token
   */
  public isTokenValid(): Observable<boolean> {
    return this.authService.isTokenValid();
  }

  public refreshToken(): void {
    this.authService.refreshToken();
  }

  public clearToken(): void {
    this.authService.clearToken();
  }
}